// Lazy loading module
export default class LazyLoad {
  constructor() {
    this.images = document.querySelectorAll("img[data-src]");
    this.init();
  }

  init() {
    if ("IntersectionObserver" in window) {
      this.setupIntersectionObserver();
    } else {
      this.loadAllImages();
    }
  }

  setupIntersectionObserver() {
    const imageObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.loadImage(entry.target);
          observer.unobserve(entry.target);
        }
      });
    });

    this.images.forEach((img) => imageObserver.observe(img));
  }

  loadImage(img) {
    img.src = img.dataset.src;
    img.classList.remove("lazy");
  }

  loadAllImages() {
    this.images.forEach((img) => this.loadImage(img));
  }
}

// Auto-initialize
new LazyLoad();
